import moment from 'moment';
import queryString from 'qs';

export const getAchievementRankRequest = (queryParams) => {
  const queries = {
    yearMonth: moment(queryParams?.yearMonth).format('yyyy-MM'),
    metric: queryParams?.metric?.value,
    brand: queryParams?.brand?.value || 'all',
  };
  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getAchievementRankRequest;
